import React from 'react';
import {
	Shopper,
	OrderProduct,
	SetProductWithParentId,
	MatchedProduct,
	CurrencyObject,
	PartialWithId,
} from 'common/types';
import ProductSet from './ProductSet';
import ProductItem from './ProductItem';

interface Props {
	product: OrderProduct;
	shopper: Shopper;
	selectedNonSetProductIds: string[];
	selectedSetProducts: SetProductWithParentId[];
	productToSetHighlightFor: MatchedProduct | null;
	editingPrice: boolean;
	editingShopper: boolean;
	currency: CurrencyObject;
	setProductPriceEdit: (data: PartialWithId<OrderProduct>) => void;
}

export const ProductContainer = (props: Props) => {
	const {
		product,
		shopper,
		selectedNonSetProductIds,
		selectedSetProducts,
		productToSetHighlightFor,
		editingPrice,
		editingShopper,
		currency,
		setProductPriceEdit,
	} = props;

	const isProductToHighlight = (product: OrderProduct): boolean =>
		!!productToSetHighlightFor &&
		productToSetHighlightFor.orderProductId === product.id &&
		productToSetHighlightFor.setIndex === null;

	return (
		<div>
			<div>
				{product.set ? (
					<ProductSet
						product={product}
						shopper={shopper}
						selectedNonSetProductIds={selectedNonSetProductIds}
						selectedSetProducts={selectedSetProducts}
						productToSetHighlightFor={props.productToSetHighlightFor}
						editingPrice={editingPrice}
						editingShopper={editingShopper}
						currency={currency}
						setProductPriceEdit={setProductPriceEdit}
					/>
				) : (
					<ProductItem
						setProduct={false}
						productId={product.id}
						product={product}
						productToUpdate={product}
						shopper={shopper}
						setIndex={undefined}
						selectedNonSetProductIds={selectedNonSetProductIds}
						selectedSetProducts={selectedSetProducts}
						highlightProduct={isProductToHighlight(product)}
						editingPrice={editingPrice}
						editingShopper={editingShopper}
						currency={currency}
						setProductPriceEdit={setProductPriceEdit}
					/>
				)}
			</div>
		</div>
	);
};

export default ProductContainer;
